import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { OrderDetailTitle } from 'src/pages/orders/components/orderDetails/OrderDetails.styled';
import CollapsableCard from 'src/common/refactoredComponents/collapsableCard/CollapsableCard.jsx';
import {
    TabMenuContainer,
    MenuItem,
    OptionsContainer,
    TextContainer,
    SearchContainer,
    ErrorText,
    OrderDetailFooterContainer,
    InvoiceCreatedDetail,
    WrapperContainer,
} from './ShipAndTrack.styled';
import ShipAndTrackDetails from 'src/pages/orders/components/orderDetails/shipAndTrack/shipAndTrackDetails/ShipAndTrackDetails';
import HighlightSearch from 'src/pages/orders/components/orderDetails/shipAndTrack/highlightSearch/HighlightSearch';
import {
    getDisplayDate,
    getBrowserTimeZoneName,
    getShortDayName,
} from 'src/utils/dateUtils';
import { convertTime24To12 } from 'src/utils/util';
import { ShipTrackLabels } from 'src/constants/orderListConstants';
import Highlighter from 'react-highlight-words';
import { useTranslation } from 'react-i18next';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const ShipAndTrack = ({ handleSetItemClick, ordersList }) => {
    const [expandedCard, setExpandedCard] = useState({
        tissue: false,
        nonTissue: false,
    });

    const [modifyDate, setModifyDate] = useState('');
    const [modifyTime, setModifyTime] = useState('');
    const { t } = useTranslation();

    const [menu, setMenu] = useState({
        all: true,
        shipped: false,
        pending: false,
    });
    const { isLanguageChanged } = useSelector((state) => ({
        isLanguageChanged: state.loginReducer.isLanguageChanged,
    }));
    const isCondensedView = useSelector(
        (state) => state.loginReducer.isCondensedView
    );
    const [searchValue, setSearchValue] = useState('');
    const [isRecordNotFound, setIsRecordNotFound] = useState(false);
    const [searchText, setSearchText] = useState([]);
    const [showNoRecord, setNoShowRecord] = useState(false);

    const [shipAndTrackFiltered, setShipAndTrackFiltered] = useState([]);
    const [tissueBasedShipAndTrack, setTissueBasedShipAndTrack] = useState([]);
    const [nontissueBasedShipAndTrack, setNonTissueBasedShipAndTrack] =
        useState([]);
    const [
        nonTissueOrderSplitOnOrderNumber,
        setNonTissueOrderSplitOnOrderNumber,
    ] = useState([]);
    const [allCount, setAllCount] = useState(0);
    const [shippedCount, setShippedCount] = useState(0);
    const [pendingCount, setPendingCount] = useState(0);
    const { shipAndTrack } = useSelector((state) => state.orderSummaryReducer);
    const { orderBasicDetails, lastModifiedBy, lastModifiedDate } = useSelector(
        (state) => ({
            orderBasicDetails: state.orderSummaryReducer.orderBasicDetails,
            lastModifiedBy:
                state.orderSummaryReducer.orderBasicDetails?.orderSummaryDetail
                    ?.lastModifiedBy,
            lastModifiedDate:
                state.orderSummaryReducer.orderBasicDetails?.orderSummaryDetail
                    ?.lastModifiedDate,
        })
    );

    useEffectWithErrorLogging(() => {
        if (lastModifiedDate && lastModifiedDate !== '') {
            setModifyDate(getDisplayDate(new Date(lastModifiedDate)));
            setModifyTime(convertTime24To12(new Date(lastModifiedDate)));
        }
    }, [lastModifiedDate]);

    useEffectWithErrorLogging(() => {
        if (shipAndTrack && shipAndTrack?.length && shipAndTrack?.length > 0) {
            setShipAndTrackFiltered(shipAndTrack);

            const tissueOrders = shipAndTrack?.filter(
                (item) => item?.salesOrg && item.salesOrg === 'S030'
            );
            if (tissueOrders?.length && tissueOrders.length > 0) {
                setTissueBasedShipAndTrack(tissueOrders[0]);
            }

            const nonTissueOrders = shipAndTrack?.filter(
                (item) => item?.salesOrg && item.salesOrg !== 'S030'
            );

            if (nonTissueOrders?.length && nonTissueOrders.length > 0) {
                setNonTissueBasedShipAndTrack(nonTissueOrders[0]);
                const groupItemsByOrderNumber = nonTissueOrders.reduce(
                    (prev, curr) => {
                        prev[curr.sapOrderId] = prev[curr.sapOrderId] || {
                            products: [],
                            isExpanded: false,
                        };
                        prev[curr.sapOrderId].products.push(curr);
                        return prev;
                    },
                    {}
                );
                setNonTissueOrderSplitOnOrderNumber(groupItemsByOrderNumber);
            }

            const allCount = shipAndTrack
                ?.map((item) => {
                    return item?.products && item?.products?.length
                        ? item.products.length > 0
                            ? item.products.length
                            : 0
                        : 0;
                })
                .reduce((acc, value) => {
                    return (acc += value);
                }, 0);
            setAllCount(allCount);
            const shippingCount = shipAndTrack
                ?.map((item) => {
                    return !item.isPending &&
                        item?.products &&
                        item?.products?.length
                        ? item.products.length > 0
                            ? item.products.length
                            : 0
                        : 0;
                })
                .reduce((acc, value) => {
                    return (acc += value);
                }, 0);
            setShippedCount(shippingCount);
            const pendingCount = shipAndTrack
                ?.map((item) => {
                    return item.isPending &&
                        item?.products &&
                        item?.products?.length
                        ? item.products.length > 0
                            ? item.products.length
                            : 0
                        : 0;
                })
                .reduce((acc, value) => {
                    return (acc += value);
                }, 0);
            setPendingCount(pendingCount);
        }
    }, [shipAndTrack]);

    useEffectWithErrorLogging(() => {
        const search = [];
        search.push(searchValue);
        setSearchText(search);
    }, [searchValue]);

    const toggleCard = (name, value) => {
        setExpandedCard({
            ...expandedCard,
            [name]: value,
        });
    };
    const toggleCardBasedOnOrderNumber = (orderNumber, value) => {
        setNonTissueOrderSplitOnOrderNumber({
            ...nonTissueOrderSplitOnOrderNumber,
            [orderNumber]: {
                ...nonTissueOrderSplitOnOrderNumber[orderNumber],
                isExpanded: value,
            },
        });
    };

    const toggleMenu = (name) => {
        switch (name) {
            case 'all':
                setMenu({
                    ...menu,
                    [name]: true,
                    shipped: false,
                    pending: false,
                });
                break;
            case 'shipped':
                setMenu({
                    ...menu,
                    [name]: true,
                    all: false,
                    pending: false,
                });
                break;
            case 'pending':
                setMenu({
                    ...menu,
                    [name]: true,
                    shipped: false,
                    all: false,
                });
                break;
            default:
                break;
        }
        const checkShipTrackList = filterShipTrack(
            shipAndTrackFiltered,
            '',
            name === 'shipped' ? false : name === 'pending' ? true : 'All'
        );
        checkShipTrackList.length > 0
            ? setNoShowRecord(false)
            : setNoShowRecord(true);
    };

    const { tissue, nonTissue } = expandedCard;

    const clearSearch = () => {
        setSearchValue('');
        setIsRecordNotFound(false);
    };
    const onSearchChangeHandler = (event) => {
        event.preventDefault();
        setSearchValue(event.target.value);

        if (shipAndTrack?.length > 0 && event.target.value !== '') {
            const searchFilter = arraySearch(shipAndTrack, event.target.value);
            setIsRecordNotFound(searchFilter);
        } else {
            setIsRecordNotFound(false);
        }
    };

    const dateFormatter = (date, isDay) => {
        const shippedDay = getShortDayName(new Date(date).getDay());
        const shippedDate = getDisplayDate(new Date(date));
        const shippedTime = convertTime24To12(new Date(date));
        const timeZone = getBrowserTimeZoneName();

        const dateFormat = isDay
            ? isLanguageChanged
                ? `${shippedDate} ${shippedDay} ${shippedTime} ${timeZone}`
                : `${shippedDay} ${shippedDate} ${shippedTime} ${timeZone}`
            : `${shippedDate} | ${shippedTime} ${timeZone}`;

        return dateFormat;
    };

    const textHighlightedWords = (data) => {
        return (
            <Highlighter
                searchWords={searchText}
                autoEscape={true}
                textToHighlight={data}
            />
        );
    };

    // Helper function to safely escape regex special characters to prevent ReDoS attacks
    const escapeRegExp = (str) => {
        if (typeof str !== 'string') return '';
        return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
    };

    const arraySearch = (array, searchValue) => {
        const searchTerm = escapeRegExp(searchValue.toLowerCase());
        const searchRegex = new RegExp(searchTerm, 'g');
        const shipTrackSearch = array.filter((value) => {
            const productSearchFilter =
                value?.products?.length > 0
                    ? value?.products?.filter(
                          (x) =>
                              x?.cfn
                                  ?.toLowerCase()
                                  .match(searchRegex) ||
                              x?.description
                                  ?.toLowerCase()
                                  .match(searchRegex) ||
                              x?.quantity
                                  ?.toLowerCase()
                                  .match(searchRegex) ||
                              x?.serialNumber
                                  ?.toLowerCase()
                                  .match(searchRegex)
                      )
                    : [];

            const isProduct = productSearchFilter?.length > 0 ? true : false;

            const trackingFilter =
                value?.trackingNoAndUrl?.entry?.length > 0
                    ? value?.trackingNoAndUrl?.entry?.filter((x) =>
                          x?.key
                              ?.toLowerCase()
                              .match(searchRegex)
                      )
                    : [];
            const isTracking = trackingFilter?.length > 0 ? true : false;
            const shippedOn = value?.shippedOn
                ? dateFormatter(value.shippedOn, true)
                      .toLowerCase()
                      .match(searchRegex)
                : false;
            const lastUpdate = value?.lastUpdated
                ? dateFormatter(value.lastUpdated, false)
                      .toLowerCase()
                      .match(searchRegex)
                : false;
            const AccountField =
                value?.shipTo && value?.shipToAccName
                    ? value.shipToAccName +
                      ' ' +
                      value.shipTo.toString().replace(/^0+/, '')
                    : value?.shipTo
                    ? value.shipTo.toString().replace(/^0+/, '')
                    : value?.shipToAccName
                    ? value.shipToAccName
                    : null;
            const isAccountField =
                AccountField !== null
                    ? AccountField.toLowerCase().match(
                          searchRegex
                      )
                    : false;

            const orderLabel = value?.sapOrderId
                ? `${ShipTrackLabels()['sapOrderId']}: ${value.sapOrderId} (${
                      value.salesOrg === 'S002'
                          ? ShipTrackLabels()['salesOrgNonTissue']
                          : value.salesOrg === 'S030' &&
                            ShipTrackLabels()['salesOrgTissue']
                  })`
                      .toLowerCase()
                      .match(searchRegex)
                : false;

            const carrierLabel = value?.carrier
                ? value?.carrier
                      .toLowerCase()
                      .match(searchRegex)
                : false;
            const carreierHeaderLabel =
                value?.carrier && value?.trackingNoAndUrl?.entry?.length > 0
                    ? `${value?.carrier} # ${value?.trackingNoAndUrl?.entry[0]?.key}`
                          .toLowerCase()
                          .match(searchRegex)
                    : false;          
            const salesOrgLabel = value?.salesOrg
                ? value.salesOrg === 'S002'
                    ? ShipTrackLabels()['salesOrgNonTissue'].toLowerCase()
                          .match(searchRegex)
                    : value.salesOrg === 'S030' &&
                      ShipTrackLabels()['salesOrgTissue'].toLowerCase()
                          .match(searchRegex)
                : false;
            const shipToLabel =
                value?.shipTo || value?.shipToAccName
                    ? ShipTrackLabels()['shippedToLabel'].toLowerCase()
                          .match(searchRegex)
                    : false;
            const shippedOnLabel = value?.shippedOn
                ? ShipTrackLabels()['shippedOn'].toLowerCase()
                      .match(searchRegex)
                : false;
            const deleiveryNoLabel = value?.deliveryNo
                ? ShipTrackLabels()['deliveryNo'].toLowerCase()
                      .match(searchRegex)
                : false;            const plantLabel = value?.plant
                ? ShipTrackLabels()['plant'].toLowerCase()
                      .match(searchRegex)
                : false;           
            const freightTypeLabel = value?.freightType
                ? ShipTrackLabels()['freightType'].toLowerCase()
                      .match(searchRegex)
                : false;            
            const trackingLabel =
                value?.trackingNoAndUrl?.entry?.length > 0
                    ? ShipTrackLabels()['trackingNoAndUrl'].toLowerCase()
                          .match(searchRegex)
                    : false;            const lastUpdateLabel =
                value?.lastUpdated > 0
                    ? ShipTrackLabels()['lastUpdated'].toLowerCase()
                          .match(searchRegex)
                    : false;            const productLabels =
                value?.products && value.products?.length > 0
                    ? ShipTrackLabels()['productsTitle'].toLowerCase()
                          .match(searchRegex) ||
                      ShipTrackLabels()['productItemDescriptionLabel'].toLowerCase()
                          .match(searchRegex) ||
                      ShipTrackLabels()['productQuantityLabel'].toLowerCase()
                          .match(searchRegex)
                    : false;            
                const setLabel = ShipTrackLabels()['setLabel'].toLowerCase()
                .match(searchRegex);            
                const tbdTitleLabel = ShipTrackLabels()['tbdTitle'].toLowerCase()
                .match(searchRegex);           
                const lotLabel = ShipTrackLabels()['lotLabel'].toLowerCase()
                .match(searchRegex);
            const labels =
                orderLabel ||
                carrierLabel ||
                carreierHeaderLabel ||
                salesOrgLabel ||
                shipToLabel ||
                shippedOnLabel ||
                deleiveryNoLabel ||
                plantLabel ||
                freightTypeLabel ||
                trackingLabel ||
                productLabels ||
                lastUpdateLabel ||
                setLabel ||
                tbdTitleLabel ||
                lotLabel;

            return (
                value?.deliveryNo
                    ?.toLowerCase()
                    ?.match(searchRegex) ||
                value?.freightType
                    ?.toLowerCase()
                    ?.match(searchRegex) ||
                value?.plant
                    ?.toLowerCase()
                    ?.match(searchRegex) ||
                value?.salesOrg
                    ?.toLowerCase()
                    ?.match(searchRegex) ||
                value?.sapOrderId
                    ?.toLowerCase()
                    ?.match(searchRegex) ||
                isAccountField ||
                isProduct ||
                isTracking ||
                shippedOn ||
                lastUpdate ||
                labels
            );
        });
        return shipTrackSearch?.length > 0 ? false : true;
    };

    const filterShipTrack = (
        shipAndTrackItem,
        orderType,
        isStatus,
        orderNumber = ''
    ) => {
        let showShipTrack = [];
        if (orderType === '' && isStatus !== 'All') {
            showShipTrack = shipAndTrackItem.filter(
                (item) => item.isPending === isStatus
            );
        } else if (orderType === '' && isStatus === 'All') {
            showShipTrack = [...shipAndTrackItem];
        } else if (isStatus !== 'All' && orderType !== '') {
            showShipTrack = shipAndTrackItem.filter(
                (item) =>
                    item.salesOrg === orderType &&
                    item.isPending === isStatus &&
                    item.sapOrderId === orderNumber
            );
        } else if (isStatus === 'All' && orderType !== '') {
            showShipTrack = shipAndTrackItem.filter(
                (item) =>
                    item.salesOrg === orderType &&
                    item.sapOrderId === orderNumber
            );
        }
        return showShipTrack;
    };

    const shipTrackDetailsHandler = (
        shipAndTrackItem,
        orderType,
        isStatus,
        orderNumber
    ) => {
        const shipTrackList = filterShipTrack(
            shipAndTrackItem,
            orderType,
            isStatus,
            orderNumber
        );
        return shipTrackList?.length > 0
            ? shipTrackList.map((data) => {
                  return (
                      <ShipAndTrackDetails
                          key={data.deliveryNo}
                          details={data}
                          searchText={searchText}
                          handleSetItemClick={handleSetItemClick}
                          ordersList={ordersList}
                          dateFormatter={dateFormatter}
                          isLanguageChanged={isLanguageChanged}
                      />
                  );
              })
            : null;
    };

    const checkNonTissueEmpty =
        Object.keys(nontissueBasedShipAndTrack).length === 0 &&
        nontissueBasedShipAndTrack.constructor === Object;

    const checkTissueEmpty =
        Object.keys(tissueBasedShipAndTrack).length === 0 &&
        tissueBasedShipAndTrack.constructor === Object;

    return (
        <>
            <OrderDetailTitle
                mbMargin={isCondensedView && '10px 0px 20px 14px'}
            >
                {t('orders.orderDetails.shipAndTrack.shiptrack')}
            </OrderDetailTitle>
            <OptionsContainer
                mbMargin={
                    isCondensedView ? '10px 12px 5px 14px' : '10px 0 5px 0'
                }
            >
                <TabMenuContainer>
                    <MenuItem
                    id="orders-shipandtrack-menu-all-item"
                        onClick={() => toggleMenu('all')}
                        selected={menu.all}
                        margin={'0'}
                    >
                        {t('orders.orderDetails.shipAndTrack.all')} ({allCount})
                    </MenuItem>
                    <MenuItem
                    id="orders-shipandtrack-menu-shipped-item"
                        onClick={() => toggleMenu('shipped')}
                        selected={menu.shipped}
                    >
                        {t('orders.orderDetails.shipAndTrack.shipped')} (
                        {shippedCount})
                    </MenuItem>
                    <MenuItem
                     id="orders-shipandtrack-menu-pending-item"
                        onClick={() => toggleMenu('pending')}
                        selected={menu.pending}
                    >
                        {t('orders.orderDetails.shipAndTrack.pending')} (
                        {pendingCount})
                    </MenuItem>
                </TabMenuContainer>
                {menu.pending &&
                shipAndTrack?.filter((item) => {
                    return item.isPending === true;
                }).length === 0 ? (
                    ''
                ) : (
                    <>
                        <SearchContainer>
                            <ErrorText>
                                {isRecordNotFound
                                    ? ordersList?.currentOrderType === 'KE'
                                        ? t(
                                              'orders.orderDetails.shipAndTrack.noresult'
                                          )
                                        : t(
                                              'orders.orderDetails.shipAndTrack.norecord'
                                          )
                                    : null}
                            </ErrorText>
                            <HighlightSearch
                                searchValue={searchValue}
                                searchHandler={onSearchChangeHandler}
                                ShipPlaceholder={true}
                                clearSearch={clearSearch}
                                cursor={'pointer'}
                                isEquity={
                                    ordersList?.currentOrderType === 'ZOR'
                                        ? true
                                        : false
                                }
                            />
                        </SearchContainer>
                    </>
                )}
            </OptionsContainer>

            <>
                {!showNoRecord &&
                !checkNonTissueEmpty &&
                nontissueBasedShipAndTrack?.sapOrderId ? (
                    <>
                        {Object.keys(nonTissueOrderSplitOnOrderNumber)
                            .sort((a, b) => parseInt(b) - parseInt(a))
                            .map((orderNumber) => {
                                const nontissueBasedShipAndTrack =
                                    nonTissueOrderSplitOnOrderNumber[
                                        orderNumber
                                    ].products[0];
                                const isExpanded =
                                    nonTissueOrderSplitOnOrderNumber[
                                        orderNumber
                                    ].isExpanded;
                                return (
                                    <CollapsableCard
                                        id={'orders-shipAndTrack-shipAndTrack-nonTissueOrder-sapOrderId'}
                                        title={textHighlightedWords(
                                            nontissueBasedShipAndTrack?.sapOrderId !==
                                                ''
                                                ? `${t(
                                                      'orders.shipTrackLabels.sapOrderId'
                                                  )}: ${
                                                      nontissueBasedShipAndTrack.sapOrderId
                                                  } ${
                                                      nontissueBasedShipAndTrack?.salesOrg ===
                                                      'S002'
                                                          ? '(Non-Tissue)'
                                                          : ''
                                                  }`
                                                : nontissueBasedShipAndTrack?.salesOrg ===
                                                      'S002' && '(Non-Tissue)'
                                        )}
                                        onClick={() =>
                                            toggleCardBasedOnOrderNumber(
                                                orderNumber,
                                                !isExpanded
                                            )
                                        }
                                        isExpanded={isExpanded}
                                        padding={'16px'}
                                        key={
                                            nontissueBasedShipAndTrack.sapOrderId
                                        }
                                        titleFontSize={'15px'}
                                        cursor={'pointer'}
                                        currentActivity
                                    >
                                        {isExpanded
                                            ? shipTrackDetailsHandler(
                                                  shipAndTrackFiltered,
                                                  nontissueBasedShipAndTrack.salesOrg,
                                                  menu.shipped
                                                      ? false
                                                      : menu.pending
                                                      ? true
                                                      : 'All',
                                                  orderNumber
                                              )
                                            : null}
                                    </CollapsableCard>
                                );
                            })}
                    </>
                ) : null}

                {!showNoRecord &&
                !checkTissueEmpty &&
                tissueBasedShipAndTrack?.sapOrderId ? (
                    <>
                        <CollapsableCard
                            id={'orders-shipAndTrack-shipAndTrack-tissueOrder-orderStatuses'}
                            title={textHighlightedWords(
                                tissueBasedShipAndTrack?.sapOrderId !== ''
                                    ? `${t(
                                          'orders.shipTrackLabels.sapOrderId'
                                      )}: ${
                                          tissueBasedShipAndTrack.sapOrderId
                                      } ${t(
                                          'orders.shipTrackLabels.salesOrgTissue'
                                      )}`
                                    : t('orders.shipTrackLabels.salesOrgTissue')
                            )}
                            onClick={() => toggleCard('tissue', !tissue)}
                            isExpanded={tissue}
                            padding={'16px'}
                            key={tissueBasedShipAndTrack.sapOrderId}
                            titleFontSize={'15px'}
                            cursor={'pointer'}
                            mobileMargin={
                                orderBasicDetails?.currentOrderType === 'ZKA' &&
                                '0px 0 2px 0'
                            }
                        >
                            {tissue
                                ? shipTrackDetailsHandler(
                                      shipAndTrackFiltered,
                                      tissueBasedShipAndTrack.salesOrg,
                                      menu.shipped
                                          ? false
                                          : menu.pending
                                          ? true
                                          : t('orders.orderStatuses.all'),
                                      tissueBasedShipAndTrack.sapOrderId
                                  )
                                : null}
                        </CollapsableCard>
                    </>
                ) : null}
                {showNoRecord && (
                    <TextContainer>
                        {`${
                            menu.pending
                                ? t(
                                      'orders.orderDetails.shipAndTrack.noPendingShipments'
                                  )
                                : menu.shipped
                                ? t(
                                      'orders.orderDetails.shipAndTrack.noShippedShipments'
                                  )
                                : t(
                                      'orders.orderDetails.shipAndTrack.noShipments'
                                  )
                        }`}
                    </TextContainer>
                )}
            </>
            {orderBasicDetails?.currentOrderType === 'KE' ||
            orderBasicDetails?.currentOrderType === 'ZOR' ||
            orderBasicDetails?.currentOrderType === 'ZKA' ? (
                <OrderDetailFooterContainer>
                    {lastModifiedBy || modifyDate || modifyTime ? (
                        <>
                            <InvoiceCreatedDetail margin={'0 3px 0 0'}>
                                {isLanguageChanged && lastModifiedBy
                                    ? ''
                                    : t('orders.orderSummaryTabs.lastmodify')}
                            </InvoiceCreatedDetail>
                            {lastModifiedBy ? (
                                <>
                                    <InvoiceCreatedDetail margin={'0 3px 0 0'}>
                                        {isLanguageChanged
                                            ? t(
                                                  'orders.orderSummaryTabs.lastmodify'
                                              )
                                            : t(
                                                  'orders.orderDetails.billingSummary.by'
                                              )}
                                    </InvoiceCreatedDetail>
                                    <InvoiceCreatedDetail
                                        margin={'0 2px 0 0'}
                                        isCreatedDateBy
                                    >
                                        {lastModifiedBy}
                                    </InvoiceCreatedDetail>
                                </>
                            ) : null}
                            <WrapperContainer>
                                {modifyDate ? (
                                    <InvoiceCreatedDetail
                                        margin={'0 2px 0 -1px'}
                                    >
                                        {modifyDate}
                                    </InvoiceCreatedDetail>
                                ) : null}
                                {modifyTime ? (
                                    <InvoiceCreatedDetail>
                                        {modifyTime}{' '}
                                        {/* {(
                                            (orderBasicDetails.currentOrderType === 'KE'  || 
                                            orderBasicDetails.currentOrderType === 'ZKA'
                                            ) && ( winWidth <= sizes.mobileDevice )
                                            ) || 
                                            orderBasicDetails.currentOrderType === 'ZOR' || orderBasicDetails.currentOrderType === 'ZKA'
                                            ? 'IST'
                                            : 'EDT'} */}
                                        {orderBasicDetails?.currentOrderType ===
                                            'KE' ||
                                        orderBasicDetails?.currentOrderType ===
                                            'ZKA' ||
                                        orderBasicDetails?.currentOrderType ===
                                            'ZOR'
                                            ? 'IST'
                                            : 'EDT'}
                                    </InvoiceCreatedDetail>
                                ) : null}
                            </WrapperContainer>
                        </>
                    ) : null}
                </OrderDetailFooterContainer>
            ) : null}
        </>
    );
};

export default ShipAndTrack;
